/**
 * Contact Form.
 *
 * @todo - Currently, the module's markup is added directly in Divi and resides
 *         in the database. Move markup to a PHP template.
 */
import iframe from '../components/iframe';

const contactForm = () => {
  const iframeID = 'contact-form';
  let iframeElement;

  const init = () => {
    iframeElement = document.getElementById(iframeID);
    if (iframeElement !== null) {
      iframe(iframeElement);
    }
  };

  return {
    init,
  };
};

export default contactForm();
